/* export interface FoodCartItem {
  id: number;
  optionList?: number[];
  quantity?: number;
  storeId?: number;
  price: number;
  cartId?: number;
} */

export interface FoodCartItem {
  id: number;
  menu_id: number;
  item_code: string;
  titlehash: number;
  title: string;
  price: number;
  category: string;
  type: string;
  storeId: number;
  store: string;
  airportId: number;
  lastUpdated: number;
  isMRP: number;
  optionsAvailable: number;
  langMinimalInfoMap: any;
  cartId: number;
  quantity: number;
  locationId: number;
  menuOptions: any[];
  optionNames: string;
  optionList: number[];
  additionalPrice?: number;
  totalPrice?: number;
  size?: string;
  breadcrumbsStore?: any[];
}
export interface FoodCart {
  locationId: number;
  storeId: number;
  list: FoodCartItem[];
  totalQuantity?: number;
  totalPrice?: number;
}

export class FoodCartRequest {
  foodMenuItems: FoodCartItem[];
  constructor(foodCart: FoodCart) {
    this.foodMenuItems = foodCart.list;
  }
}

export class Cart {
  static title: string;
  static optionNames?: string;
  static quantity: number;
  static price: number;

  static toFoodCart(cartItem: any): any {
    cartItem.forEach(item => {
      this.title = item.title;
      this.price = item.price;
      this.quantity = item.quantity;
      this.optionNames = item.optionNames;
    });
  }


  static ToRetailCart(item: any) {
    this.title = item.title;
    this.price = item.price;
    this.quantity = item.quantity;
  }
}

export interface StoreMetaInfo {
  itemType: string;
  storeName: string;
  retailerName: string;
  subCategory: string;
  airportId: string;
  id: number;
  category: string;
  description: string;
  type: number;
  tags: string;
  facilityName: string;
  storeImage: string;
  status: string;
  storeImageList: string[];
  operatingHours: string;
  isMenuItemsAvailable: number;
  fos_user_id: number;
  beta: number;
  locationName: string;
}
/*
export interface CartItemDetails {
  id: number;
  menu_id: number;
  item_code: string;
  titlehash: number;
  title: string;
  price: number;
  category: string;
  type: string;
  storeId: number;
  store: string;
  airportId: number;
  lastUpdated: number;
  locationId: number;
  isMRP: number;
  optionsAvailable: number;
  langInfoMap: any[];
  quantity: number;
  cartId: number;
  optionList: number[];
  optionNames: string;
} */

export interface RetailCartItem {
  id: number;
  item_code: string;
  title: string;
  price: number;
  origPrice: number;
  finalPrice: number;
  category: string;
  type: string;
  storeId: number;
  store: string;
  airportId: number;
  lastUpdated: number;
  isMRP: number;
  optionsAvailable: number;
  langMinimalInfoMap: any;
  cartId: number;
  quantity: number;
  locationId: number;
  additionalPrice?: number;
  totalPrice?: number;
  productUrl?: string;
  size?: string;
  promotionalOffer?: any;
  appliedPromotion?: string
  additionalDiscountText?: string
}
export interface RetailCart {
  locationId: number;
  storeId: number;
  list: RetailCartItem[];
  totalQuantity?: number;
  totalPrice?: number;
}
